import { render, staticRenderFns } from "./RestricoesCashback.vue?vue&type=template&id=6d3ed046&scoped=true"
import script from "./RestricoesCashback.vue?vue&type=script&lang=js"
export * from "./RestricoesCashback.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-restricoes.css?vue&type=style&index=0&id=6d3ed046&prod&scoped=true&lang=css&external"
import style1 from "./RestricoesCashback.vue?vue&type=style&index=1&id=6d3ed046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ed046",
  null
  
)

export default component.exports